import InputAdornment from '@mui/material/InputAdornment'
import {
  colors,
  KestrixEyeIcon,
  KestrixEyeSlashIcon,
  KestrixIconButton
} from '@shared'

export const ShowPasswordButton = ({
  showPassword,
  togglePasswordVisibility
}: {
  showPassword: boolean
  togglePasswordVisibility: () => void
}) => {
  return (
    <InputAdornment position="end">
      <KestrixIconButton
        type="button"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          e.stopPropagation()
          togglePasswordVisibility()
        }}
        tooltip={showPassword ? 'Hide password' : 'Show password'}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        size="small"
        variant="default"
      >
        {showPassword ? (
          <KestrixEyeSlashIcon
            size={20}
            color={colors.base.KestrixIconColour}
          />
        ) : (
          <KestrixEyeIcon size={20} color={colors.base.KestrixIconColour} />
        )}
      </KestrixIconButton>
    </InputAdornment>
  )
}
